'use strict';

function ngEndedHandler() {
    return {
        restrict: 'A',
        scope: {
            handler: '&'
        },
        link: function (scope, iElem, iAttrs) {
            //TODO verificar sé um array
            angular.forEach(iElem, function (element){
                  element.addEventListener('ended', function () {
                    scope.handler()();
                });
            });}
    };
}

export default ngEndedHandler


// WEBPACK FOOTER //
// ./src/app/scripts/directives/ngEndedHandler.js